import React, { forwardRef, ForwardRefRenderFunction } from "react";
import { TextInputProps } from "./TextInput.types";
import "./TextInput.scss";

const TextInput: ForwardRefRenderFunction<HTMLInputElement, TextInputProps> = ({
  shape,
  error,
  success,
  leftIcon,
  rightIcon,
  defaultValue = "",
  disabled = false,
  id = null,
  name = null,
  autoComplete,
  accept,
  onAnimationStart = () => false,
  onBlur = () => false,
  onChange = () => false,
  onFocus = () => false,
  onKeyUp = () => false,
  onKeyDown = () => false,
  placeholder = null,
  readOnly = false,
  value,
  type = "text",
  label,
  textInputClassName,
  ...props
}, ref) => {
  let className = "alteon-input-wrapper";
  if (error && !success) {
    className = "alteon-input-wrapper alteon-input-error";
  }
  if (success && !error) {
    className = "alteon-input-wrapper alteon-input-success";
  }
  if (disabled) {
    className = "alteon-input-wrapper alteon-input-disabled";
  }
  const inputClass = `alteon-input alteon-input-${shape} ${textInputClassName}`;

  return (
    <div className={className}>
        {label && <label className={`alteon-input-formlabel`}>{label}</label>}

        <div className={`${inputClass} alteon-input-textfield`}>
          {leftIcon}
          <input
            data-testid={"textInput"}
            ref={ref}
            id={id}
            placeholder={placeholder}
            onChange={onChange}
            defaultValue={defaultValue}
            readOnly={readOnly}
            onKeyUp={onKeyUp}
            onKeyDown={onKeyDown}
            value={value}
            autoComplete={autoComplete}
            onBlur={onBlur}
            onFocus={onFocus}
            onAnimationStart={onAnimationStart}
            name={name}
            accept={accept}
            {...props}
            type={type}
          />
          {rightIcon}
        </div>
        {error && !disabled && !success && (
          <span className="alteon-error-text">{error}</span>
        )}
        {success && !disabled && !error && (
          <span className="alteon-success-text">{success}</span>
        )}
    </div>
  );
};

export default forwardRef(TextInput);
